import Analisa from '../../../views/Kurikulum/Analisa/Analisa.kurikulum.view';

export default Analisa;